import { Product } from "./Product";

export const AddProductFormTemplate = Object.freeze({
  sections: [
    {
      size: 7 / 12,
      compact: true,
      inputs: [Product.name, Product.text],
    },
    {
      size: 7 / 12,
      compact: true,
      inputs: [Product.price, Product.offer_price, Product.stock],
    },
    {
      size: 7 / 12,
      compact: true,
      inputs: [Product.offer, Product.visible_app],
    },
    { size: 12 / 12, compact: true, inputs: [Product.internal] },
  ],
});
